import styled from 'styled-components';

// Text Inputs 
export const StyledTextInput = styled.input<{font_size?: string; padding?:string; margin?: string; width?: string; color?:string; border_bottom?:string}>`
    font-size: ${props => !props.font_size? '20px' : props.font_size};
    border: 0;
    padding: ${props => !props.padding? '5px' : props.padding};
    margin: ${props => !props.margin? '10px auto' : props.margin};
    width: ${props => !props.width? '80%' : props.width};
    display: block;
    text-align: center;
    resize: none;
    line-height: 22px;    
    background: #fff;
    color: ${props => !props.color? '#333' : props.color};
    
    &:disabled {
        background: #FFF;
        color: #555;
    }
    
    &:focus {
        border-bottom: ${props => !props.border_bottom? '1px solid #ddd' : props.border_bottom};
    }
`;

// Text Area
export const StyledTextAreaInput = styled.textarea`
    font-size: 16px;
    border: 0;
    padding: 5px 10px;
    margin: 0px auto;
    width: 90%;
    display: block;
    resize: none;
    color: #444;
    font-size: 15px;
    line-height: 22px;
    height: 100px;
    font-family: inherit;
    background: #fff;
    color: #555;
    
    &:hover {
        // border: 1px solid #ddd;
    }
    
    &:focus {
        // border: 1px solid #ddd;
    }
`;

export const StyledItemText = styled.div`
  font-size: 14px;
  padding: 10px;
`;

